<div [formGroup]="deviceForm" class="dark:bg-black p-6">
  <h3 class="pb-2 text-primary text-l font-bold">{{dialogType | titlecase}} Node</h3>

  <fieldset class="fieldset">
    <legend class="fieldset-legend">Description</legend>
    <input type="text" class="input dark:text-white" formControlName="description" />
  </fieldset>
  <fieldset class="fieldset">
    <legend class="fieldset-legend">LoraWAN Address</legend>
    <input type="text" class="input dark:text-white" formControlName="lorawanAddress" />
    @if (deviceForm.controls.lorawanAddress.invalid && deviceForm.controls.lorawanAddress.touched) {
      @for (error of deviceForm.controls.lorawanAddress.errors | keyvalue; track error.key) {
        <div class="text-red-500 text-xs">
          @switch (error.key) {
            @case ('required') { Address is required }
            @case ('minlength') { Your input is too short, must be 8 characters }
            @case ('maxlength') { Your input is too long, must be 8 characters }
            @case ('pattern') { Only hexidecimal characters are allowed }
          }
        </div>
      }
    } @else {
      <p class="label">Format: 8 characters alphanumeric</p>
    }
  </fieldset>
  <fieldset class="fieldset">
    <legend class="fieldset-legend">NetworkSKey</legend>
    <input type="text" class="input dark:text-white" formControlName="networkKey" />
    @if (deviceForm.controls.networkKey.invalid && deviceForm.controls.networkKey.touched) {
      @for (error of deviceForm.controls.networkKey.errors | keyvalue; track error.key) {
        <div class="text-red-500 text-xs">
          @switch (error.key) {
            @case ('required') { Network Key is required }
            @case ('minlength') { Your input is too short, must be 32 characters }
            @case ('maxlength') { Your input is too long, must be 32 characters }
            @case ('pattern') { Only hexidecimal characters are allowed }
          }
        </div>
      }
    } @else {
      <p class="label">Format: 32 characters alphanumeric</p>
    }
  </fieldset>
  <div class="mt-6">
    <button (click)="confirmDevice()"
            [mat-dialog-close]="dialogData" [disabled]="!deviceForm.valid" class="btn btn-primary mr-4"> {{dialogType | titlecase}} Node</button>
    <button (click)="cancelDevice()" class="btn">Cancel</button>
  </div>

</div>
